export function hashForTracking(value: string): string {
  const HASH_SHIFT_BITS = 5; // Bit shift used in the hash mixing step.
  const HASH_OUTPUT_RADIX = 16; // Hexadecimal output for compact, readable hashes.
  let hash = 0;
  for (const ch of value) {
    const char = ch.codePointAt(0) ?? 0;
    hash = (hash << HASH_SHIFT_BITS) - hash + char;
    hash &= hash;
  }
  return `hash_${Math.abs(hash).toString(HASH_OUTPUT_RADIX)}`;
}
